import { combineReducers } from 'redux'
import localforage from 'localforage'
import { fetchData } from '../../api'
import { isClient } from '../../utils'

// caching vars

const useCaching = isClient() ? true : false;
const dataType = 'glossary'
const timeToStale = 60000; //ms

const FETCH_GLOSSARY_REQUEST = 'GLOSSARY/FETCH_GLOSSARY_REQUEST'
const FETCH_GLOSSARY_SUCCESS = 'GLOSSARY/FETCH_GLOSSARY_SUCCESS'
const FETCH_GLOSSARY_FAILURE = 'GLOSSARY/FETCH_GLOSSARY_FAILURE'
const FETCH_GLOSSARY_CACHED= 'GLOSSARY/FETCH_GLOSSARY_CACHED'

const glossary = (state = {}, action) => {

    let returnedData;

    // testing - delete localstorage
    //localforage.removeItem('GLOSSARYData')

    switch (action.type) {

        case FETCH_GLOSSARY_CACHED:      
            return action.response;

        case FETCH_GLOSSARY_SUCCESS:
            returnedData = {         
                lastFetched: Date.now(),
                data: action.response
            }

            if (useCaching) {
                localforage.setItem(dataType+'Data', {
                    lastFetched: Date.now(),
                    data: returnedData
                })  
            }

            return returnedData

        default: 
            return state
    }  
}


const reducer = combineReducers({
    glossary
})


export const fetchGlossary = () => (dispatch) => {
    
    let isDataStale = true;

    if (!useCaching) {
        dispatchAPIFetch(dispatch)
    } else {    

        localforage.getItem(dataType+'Data').then(function(cached) {

            if (cached!=null && cached.data!=null) {
                isDataStale = (Date.now() - cached.data.lastFetched) > timeToStale;     
            }

            if(isDataStale){
                dispatchAPIFetch(dispatch)
            } else {
                localforage.getItem(dataType+'Data').then(function(response) {
                    dispatch({ 
                        type: FETCH_GLOSSARY_CACHED,
                        response: response.data
                    })
                })
            }

        })
    }        
}

function dispatchAPIFetch(dispatch) {

    dispatch({type: FETCH_GLOSSARY_REQUEST})

    return fetchData('wpapi/glossary')
        .then(response => {

            dispatch({
                type: FETCH_GLOSSARY_SUCCESS,
                response
            })
        })
        .catch(error => {
            dispatch({
                type: FETCH_GLOSSARY_FAILURE,
                error
            })
        }); 
}

export const getGlossary = state => state.glossary.glossary

export default reducer



// WEBPACK FOOTER //
// ./client/modules/Glossary/redux.js